import {
  FETCH_CURRENCIES_REQUEST, FETCH_CURRENCIES_SUCCESS, FETCH_CURRENCIES_ERROR, RESET_CURRENCY_DATA,
} from './types';
import { resetCurrency } from './currencyResettingFunc';

export const getters = {};

export const mutations = {
  [FETCH_CURRENCIES_REQUEST]: (state) => {
    state.currencies.status = 'loading';
  },
  [FETCH_CURRENCIES_SUCCESS]: (state, res) => {
    state.status = 'success';
    state.lastUpdated = res.last_updated;
    state.currencies = res.objects;
  },
  [FETCH_CURRENCIES_ERROR]: (state) => {
    state.currencies.status = 'error';
  },
  [RESET_CURRENCY_DATA]: (state) => {
    resetCurrency(state);
  },
};

export const state = {
  currencies: [],
  status: '',
  lastUpdated: '',
};
